/*
 * Turns on/off drawing modes: line, multi-line and free draw.
 */

export const handleDrawingModes = (canvas, activeTool) => {
    // reset all modes
    canvas.set('isDrawingMode', false)
    canvas.set('isDrawingLineMode', false)
    canvas.set('isDrawingStraightLineMode', false)
    canvas.set('isDrawingBlockLineMode', false)
    canvas.set('isDrawingNarrowPointLineMode', false)
    canvas.set('isDrawingLineArrowMode', false)
    canvas.set('isDrawingPathMode', false)
    canvas.set('isDrawingMarkMode', false)
    canvas.set('isDrawingSinglePointMarkMode', false)
    canvas.set('isDrawingTextMode', false)

    canvas.set('isDrawingLineArrowTwoMode', false)
    canvas.set('isDrawingEndCapsLineMode', false)
    canvas.set('isDrawingLineArrowLeftRightMode', false)
    canvas.set('isDrawingRectangle', false)
    canvas.set('isDrawingTriangle', false)
    canvas.set('isDrawingCircle', false)
    canvas.set('isDrawingRectangle3Sided', false)

    canvas.defaultCursor = 'default'
    canvas.selection = true
    canvas.forEachObject((o) => {
        o.selectable = true
        o.evented = true
    })

    if (activeTool === 'select') {
        canvas.set('isDrawingTextMode', false)
        canvas.defaultCursor = 'default'
    }

    // drawing mode
    if (activeTool === 'draw') {
        canvas.set('isDrawingMode', true)
    }

    // drawing mode
    if (activeTool === 'straightLine') {
        // console.log('Hi')
        canvas.set('isDrawingStraightLineMode', true)
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    if (activeTool === 'blockLine') {
        canvas.set('isDrawingBlockLineMode', true)
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    if (activeTool === 'narrowPoint') {
        canvas.set('isDrawingNarrowPointLineMode', true)
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    // drawing line mode
    if (activeTool === 'line') {
        canvas.isDrawingLineMode = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    if (activeTool === 'endCapsLine') {
        canvas.isDrawingEndCapsLineMode = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    // drawing line mode
    if (activeTool === 'lineArrow') {
        canvas.isDrawingLineArrowMode = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    // drawing arrow line two mode
    if (activeTool === 'lineArrowTwo') {
        canvas.isDrawingLineArrowTwoMode = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    if (activeTool === 'lineArrowLeftRight') {
        canvas.isDrawingLineArrowLeftRightMode = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    if (activeTool === 'rectangle') {
        canvas.isDrawingRectangle = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    if (activeTool === 'triangle') {
        canvas.isDrawingTriangle = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }
    if (activeTool === 'circle') {
        canvas.isDrawingCircle = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    if (activeTool === 'rectangle3sided') {
        canvas.isDrawingRectangle3Sided = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    // drawing path mode
    if (activeTool === 'path') {
        canvas.isDrawingPathMode = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    // drawing path mode
    if (activeTool === 'mark') {
        canvas.isDrawingMarkMode = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    if (activeTool === 'singlePointMark') {
        canvas.isDrawingSinglePointMarkMode = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }

    // drawing text mode
    if (activeTool === 'textbox') {
        canvas.isDrawingTextMode = true
        canvas.defaultCursor = 'crosshair'
        canvas.selection = false
        canvas.forEachObject((o) => {
            o.selectable = false
            o.evented = false
        })
    }
}
